import { capitalizeAssociatedPress } from "./capitalize";

const hasCustomTitle: { [key: string]: string } = {
  product_type_category: "product type",
  adaptive: "Automatic",
};

export const valueToTitle = (value: string) => {
  return capitalizeAssociatedPress(
    hasCustomTitle[value] ?? value.replaceAll("_", " "),
  );
};
